import React from 'react';
import styles from './LimitsPermitModal.module.scss';
import { modalType, useModal } from '../../../../shared/modalProvider';
import { Empty, Modal, Spin } from 'antd';
import useLimitsPermitQuery from '../../api/useLimitsPermitQuery';

const LimitsPermitModal = () => {
  const { isOpen, props, close } = useModal(modalType.LIMITS_PERMIT_MODAL);

  const { companyId } = props || {};

  const { data: limits = {}, isFetching } = useLimitsPermitQuery(companyId, {
    enabled: Boolean(companyId && isOpen),
    staleTime: 0,
  });

  return (
    <Modal
      visible={isOpen}
      onCancel={close}
      onOk={close}
      title="Лимиты пропусков"
      cancelButtonProps={{ style: { display: 'none' } }}
      width={700}
    >
      <Spin spinning={isFetching}>
        {!!Object.keys(limits)?.length ? (
          <div className={styles.root}>
            <div>
              <div className={styles.title}>
                Максимальное количество пропусков, создаваемых через МП
                собственника
              </div>
              <div className={styles.content}>
                <div className={styles.text}>
                  <div>Постоянныx:</div>
                  <div>{limits?.permanentMobileAppMaxPermit}</div>
                </div>
                <div className={styles.text}>
                  <div>Временныx:</div>
                  <div>{limits?.tempMobileAppMaxPermit}</div>
                </div>
              </div>
            </div>
            <div>
              <div className={styles.title}>
                Максимальное количество пропусков, создаваемых через
                веб-приложение
              </div>
              <div className={styles.content}>
                <div className={styles.text}>
                  <div>Постоянныx:</div>
                  <div>{limits?.permanentWebMaxPermit}</div>
                </div>
                <div className={styles.text}>
                  <div>Временныx:</div>
                  <div>{limits?.tempWebMaxPermit}</div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Нет данных о лимитах пропусков по данной УК"
          />
        )}
      </Spin>
    </Modal>
  );
};

export default LimitsPermitModal;
